/**
 * Homepage category rail — mobile progress only.
 */
(function () {
  function init(root) {
    const track = root.querySelector('[data-kk-cats-track]');
    const fill = root.querySelector('[data-kk-cats-progress-fill]');
    if (!track || !fill) return;

    function update() {
      const max = track.scrollWidth - track.clientWidth;
      const progress = max > 0 ? track.scrollLeft / max : 0;
      fill.style.setProperty('--kk-cats-progress', `${12 + progress * 88}%`);
      root.style.setProperty('--kk-cats-progress', `${12 + progress * 88}%`);
    }

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  function boot() {
    document.querySelectorAll('.kk-home-cats').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('.kk-home-cats');
    if (root) init(root);
  });
})();
